import { createFileRoute } from "@tanstack/react-router";
import { PortfolioBreakdownPage } from "../../features/portfolio/pages/portfolio-breakdown-page";

export const Route = createFileRoute("/_layout/portfolio/breakdown")({
  component: PortfolioBreakdownPage,
});
